import { useCallback } from 'react'
import _data from 'common/utils/_data'

export interface AreaOfLawClassified {
  area_of_law: string
  confidence: number
  description: string
  specialisms: string[]
  status: string
  sub_areas: string[]
}

export const useAreaOfLawClassified = () => {
  const getAreaOfLawClassified = useCallback(async (query: string) => {
    try {
      const response = await fetch(
        'https://rq2ih15bi6.execute-api.eu-west-2.amazonaws.com/prod/predict',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ query }),
        },
      )

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data: AreaOfLawClassified = await response.json()
      return data.area_of_law
    } catch (error) {
      console.error('Error calling classifier:', error)
    }
  }, [])

  return {
    getAreaOfLawClassified,
  }
}
